import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const dattoRmm = defineConnector({
  identifier: "dattoRmm",
  name: "Datto RMM",
  tagLine: "Remote monitoring and management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ platform }) =>
    exactUrlToRegex(
      platform ? `https://${platform}-api.centrastage.net/api/` : ""
    ),
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Datto RMM platform",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the platform name from your Datto RMM API URL. For https://concord-api.centrastage.net, that name is concord.",
        },
        {
          kind: "input",
          label: "Platform",
          placeholder: "concord",
          required: true,
          target: { kind: "configuration", field: "platform" },
          helperText:
            "The platform name before -api in your API host: concord, merlot, pinotage, vidal, zinfandel, or syrah.",
        },
      ],
    },
    {
      title: "Generate API keys",
      items: [
        {
          kind: "markdown",
          content:
            "In Datto RMM, turn on API access under Setup → Global Settings, then open Setup → Users, select a user, and generate an API key and API secret. See the [Datto RMM API docs](https://rmm.datto.com/help/en/Content/2SETUP/APIv2.htm).",
        },
      ],
    },
    {
      title: "Authorize your Datto RMM account",
      items: [
        {
          kind: "markdown",
          content:
            "Click below to authorize. Datto will ask for the API key and API secret from the previous step.",
        },
        {
          kind: "oauth",
          dependsOn: [{ kind: "configuration", field: "platform" }],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://${configuration.platform}-api.centrastage.net/auth/oauth/authorize`,
    tokenEndpoint: (configuration) =>
      `https://${configuration.platform}-api.centrastage.net/auth/oauth/token`,
    tokenEndpointAuthMethod: () => "client_secret_basic_no_urlencode",
    clientCredentialsFrom: "fixed",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.platform}-api.centrastage.net/api/v2/account`,
  },
  publicEnvVars: ({ platform }) => ({
    DATTO_RMM_PLATFORM: platform || "",
  }),
});
